"use strict";

// Adapted from https://github.com/jquery/jquery-ui/blob/master/ui/position.js:
// - commonjsified
// - does not depend on jquery ui

// description: Positions elements relative to other elements.
// docs: http://api.jqueryui.com/position/
// demos: http://jqueryui.com/position/

var $ = require('dibs-jquery-shim');
var cachedScrollbarWidth;
var max = Math.max;
var abs = Math.abs;
var round = Math.round;
var rhorizontal = /left|center|right/;
var rvertical = /top|center|bottom/;
var roffset = /[\+\-]\d+(\.[\d]+)?%?/;
var rposition = /^\w+/;
var rpercent = /%$/;
// Support: IE <=9 only
var supportsOffsetFractions = function () {
    var element = $("<div>")
        .css("position", "absolute")
        .appendTo("body")
        .offset({
            top: 1.5,
            left: 1.5
        }),
        support = element.offset().top === 1.5;

    element.remove();

    supportsOffsetFractions = function () {
        return support;
    };

    return support;
};
var getOffsets = function (offsets, width, height) {
    return [
        parseFloat(offsets[0]) * (rpercent.test(offsets[0]) ? width / 100 : 1),
        parseFloat(offsets[1]) * (rpercent.test(offsets[1]) ? height / 100 : 1)
    ];
};
var parseCss = function (element, property) {
    return parseInt($.css(element, property), 10) || 0;
};
var getDimensions = function (elem) {
    var raw = elem[0];
    if (raw.nodeType === 9) {
        return {
            width: elem.width(),
            height: elem.height(),
            offset: { top: 0, left: 0 }
        };
    }
    if ($.isWindow(raw)) {
        return {
            width: elem.width(),
            height: elem.height(),
            offset: { top: elem.scrollTop(), left: elem.scrollLeft() }
        };
    }
    if (raw.preventDefault) {
        return {
            width: 0,
            height: 0,
            offset: { top: raw.pageY, left: raw.pageX }
        };
    }
    return {
        width: elem.outerWidth(),
        height: elem.outerHeight(),
        offset: elem.offset()
    };
};
var scrollbarWidth = function () {
    var div;
    var innerDiv;
    var w1;
    var w2;
    if (cachedScrollbarWidth !== undefined) {
        return cachedScrollbarWidth;
    }
    div = $("<div style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>");
    innerDiv = div.children()[0];
    $("body").append(div);
    w1 = innerDiv.offsetWidth;
    div.css("overflow", "scroll");
    w2 = innerDiv.offsetWidth;
    if (w1 === w2) {
        w2 = div[0].clientWidth;
    }
    div.remove();
    return (cachedScrollbarWidth = w1 - w2);
};
var getScrollInfo = function (within) {
    var overflowX = within.isWindow || within.isDocument ? "" : within.element.css("overflow-x");
    var overflowY = within.isWindow || within.isDocument ? "" : within.element.css("overflow-y");
    var hasOverflowX = overflowX === "scroll" || (overflowX === "auto" && within.width < within.element[0].scrollWidth);
    var hasOverflowY = overflowY === "scroll" || (overflowY === "auto" && within.height < within.element[0].scrollHeight);
    return {
        width: hasOverflowY ? scrollbarWidth() : 0,
        height: hasOverflowX ? scrollbarWidth() : 0
    };
};
var getWithinInfo = function (element) {
    var withinElement = $(element || window);
    var isWindow = $.isWindow(withinElement[0]);
    var isDocument = !!withinElement[0] && withinElement[0].nodeType === 9;
    return {
        element: withinElement,
        isWindow: isWindow,
        isDocument: isDocument,
        offset: withinElement.offset() || { left: 0, top: 0 },
        scrollLeft: withinElement.scrollLeft(),
        scrollTop: withinElement.scrollTop(),
        width: withinElement.outerWidth(),
        height: withinElement.outerHeight()
    };
};

var uiPosition = module.exports = {
    positionElement: function (element, options) {
        // make a copy, we don't want to modify arguments
        var $element;
        var target;
        var within;
        var scrollInfo;
        var collision;
        var offsets = {};
        var collisionPosition;
        var using;
        var elemWidth;
        var elemHeight;
        var marginLeft;
        var marginTop;
        var collisionWidth;
        var collisionHeight;
        var position;
        var myOffset;
        var atOffset;
        var targetWidth;
        var targetHeight;
        var targetOffset;
        var basePosition;
        var dimensions;

        options = $.extend({}, options);

        target = $(options.of);
        within = getWithinInfo(options.within);
        scrollInfo = getScrollInfo(within);
        collision = (options.collision || "flip").split(" ");

        dimensions = getDimensions(target);
        if (target[0].preventDefault) {
            // force left top to allow flipping
            options.at = "left top";
        }
        targetWidth = dimensions.width;
        targetHeight = dimensions.height;
        targetOffset = dimensions.offset;
        // clone to reuse original targetOffset later
        basePosition = $.extend({}, targetOffset);

        // force my and at to have valid horizontal and vertical positions
        // if a value is missing or invalid, it will be converted to center
        $.each(["my", "at"], function () {
            var pos = (options[this] || "").split(" "),
                horizontalOffset,
                verticalOffset;

            if (pos.length === 1) {
                pos = rhorizontal.test(pos[0]) ?
                    pos.concat(["center"]) :
                    rvertical.test(pos[0]) ?
                        ["center"].concat(pos) :
                        ["center", "center"];
            }
            pos[0] = rhorizontal.test(pos[0]) ? pos[0] : "center";
            pos[1] = rvertical.test(pos[1]) ? pos[1] : "center";

            // calculate offsets
            horizontalOffset = roffset.exec(pos[0]);
            verticalOffset = roffset.exec(pos[1]);
            offsets[this] = [
                horizontalOffset ? horizontalOffset[0] : 0,
                verticalOffset ? verticalOffset[0] : 0
            ];

            // reduce to just the positions without the offsets
            options[this] = [
                rposition.exec(pos[0])[0],
                rposition.exec(pos[1])[0]
            ];
        });

        // normalize collision option
        if (collision.length === 1) {
            collision[1] = collision[0];
        }

        if (options.at[0] === "right") {
            basePosition.left += targetWidth;
        } else if (options.at[0] === "center") {
            basePosition.left += targetWidth / 2;
        }

        if (options.at[1] === "bottom") {
            basePosition.top += targetHeight;
        } else if (options.at[1] === "center") {
            basePosition.top += targetHeight / 2;
        }

        atOffset = getOffsets(offsets.at, targetWidth, targetHeight);
        basePosition.left += atOffset[0];
        basePosition.top += atOffset[1];

        $element = $(element);
        elemWidth = $element.outerWidth();
        elemHeight = $element.outerHeight();
        marginLeft = parseCss(element, "marginLeft");
        marginTop = parseCss(element, "marginTop");
        collisionWidth = elemWidth + marginLeft + parseCss(element, "marginRight") + scrollInfo.width;
        collisionHeight = elemHeight + marginTop + parseCss(element, "marginBottom") + scrollInfo.height;
        position = $.extend({}, basePosition);
        myOffset = getOffsets(offsets.my, $element.outerWidth(), $element.outerHeight());

        if (options.my[0] === "right") {
            position.left -= elemWidth;
        } else if (options.my[0] === "center") {
            position.left -= elemWidth / 2;
        }

        if (options.my[1] === "bottom") {
            position.top -= elemHeight;
        } else if (options.my[1] === "center") {
            position.top -= elemHeight / 2;
        }

        position.left += myOffset[0];
        position.top += myOffset[1];

        // if the browser doesn't support fractions, then round for consistent results
        if (!supportsOffsetFractions()) {
            position.left = round(position.left);
            position.top = round(position.top);
        }

        collisionPosition = {
            marginLeft: marginLeft,
            marginTop: marginTop
        };

        $.each(["left", "top"], function (i, dir) {
            if (uiPosition[collision[i]]) {
                uiPosition[collision[i]][dir](position, {
                    targetWidth: targetWidth,
                    targetHeight: targetHeight,
                    elemWidth: elemWidth,
                    elemHeight: elemHeight,
                    collisionPosition: collisionPosition,
                    collisionWidth: collisionWidth,
                    collisionHeight: collisionHeight,
                    offset: [atOffset[0] + myOffset[0], atOffset[1] + myOffset[1]],
                    my: options.my,
                    at: options.at,
                    within: within,
                    elem: $element
                });
            }
        });

        if (options.using) {
            // adds feedback as second argument to using callback, if present
            using = function (props) {
                var left = targetOffset.left - position.left,
                    right = left + targetWidth - elemWidth,
                    top = targetOffset.top - position.top,
                    bottom = top + targetHeight - elemHeight,
                    feedback = {
                        target: {
                            element: target,
                            left: targetOffset.left,
                            top: targetOffset.top,
                            width: targetWidth,
                            height: targetHeight
                        },
                        element: {
                            element: $element,
                            left: position.left,
                            top: position.top,
                            width: elemWidth,
                            height: elemHeight
                        },
                        horizontal: right < 0 ? "left" : left > 0 ? "right" : "center",
                        vertical: bottom < 0 ? "top" : top > 0 ? "bottom" : "middle"
                    };
                if (targetWidth < elemWidth && abs(left + right) < targetWidth) {
                    feedback.horizontal = "center";
                }
                if (targetHeight < elemHeight && abs(top + bottom) < targetHeight) {
                    feedback.vertical = "middle";
                }
                if (max(abs(left), abs(right)) > max(abs(top), abs(bottom))) {
                    feedback.important = "horizontal";
                } else {
                    feedback.important = "vertical";
                }
                options.using.call(element, props, feedback);
            };
        }

        $element.offset($.extend(position, {using: using}));
    },
    fit: {
        left: function (position, data) {
            var within = data.within,
                withinOffset = within.isWindow ? within.scrollLeft : within.offset.left,
                outerWidth = within.width,
                collisionPosLeft = position.left - data.collisionPosition.marginLeft,
                overLeft = withinOffset - collisionPosLeft,
                overRight = collisionPosLeft + data.collisionWidth - outerWidth - withinOffset,
                newOverRight;

            // element is wider than within
            if (data.collisionWidth > outerWidth) {
                // element is initially over the left side of within
                if (overLeft > 0 && overRight <= 0) {
                    newOverRight = position.left + overLeft + data.collisionWidth - outerWidth - withinOffset;
                    position.left += overLeft - newOverRight;
                // element is initially over right side of within
                } else if (overRight > 0 && overLeft <= 0) {
                    position.left = withinOffset;
                // element is initially over both left and right sides of within
                } else {
                    if (overLeft > overRight) {
                        position.left = withinOffset + outerWidth - data.collisionWidth;
                    } else {
                        position.left = withinOffset;
                    }
                }
            // too far left -> align with left edge
            } else if (overLeft > 0) {
                position.left += overLeft;
            // too far right -> align with right edge
            } else if (overRight > 0) {
                position.left -= overRight;
            // adjust based on position and margin
            } else {
                position.left = max(position.left - collisionPosLeft, position.left);
            }
        },
        top: function (position, data) {
            var within = data.within,
                withinOffset = within.isWindow ? within.scrollTop : within.offset.top,
                outerHeight = data.within.height,
                collisionPosTop = position.top - data.collisionPosition.marginTop,
                overTop = withinOffset - collisionPosTop,
                overBottom = collisionPosTop + data.collisionHeight - outerHeight - withinOffset,
                newOverBottom;

            // element is taller than within
            if (data.collisionHeight > outerHeight) {
                // element is initially over the top of within
                if (overTop > 0 && overBottom <= 0) {
                    newOverBottom = position.top + overTop + data.collisionHeight - outerHeight - withinOffset;
                    position.top += overTop - newOverBottom;
                // element is initially over bottom of within
                } else if (overBottom > 0 && overTop <= 0) {
                    position.top = withinOffset;
                // element is initially over both top and bottom of within
                } else {
                    if (overTop > overBottom) {
                        position.top = withinOffset + outerHeight - data.collisionHeight;
                    } else {
                        position.top = withinOffset;
                    }
                }
            // too far up -> align with top
            } else if (overTop > 0) {
                position.top += overTop;
            // too far down -> align with bottom edge
            } else if (overBottom > 0) {
                position.top -= overBottom;
            // adjust based on position and margin
            } else {
                position.top = max(position.top - collisionPosTop, position.top);
            }
        }
    },
    flip: {
        left: function (position, data) {
            var within = data.within,
                withinOffset = within.offset.left + within.scrollLeft,
                outerWidth = within.width,
                offsetLeft = within.isWindow ? within.scrollLeft : within.offset.left,
                collisionPosLeft = position.left - data.collisionPosition.marginLeft,
                overLeft = collisionPosLeft - offsetLeft,
                overRight = collisionPosLeft + data.collisionWidth - outerWidth - offsetLeft,
                myOffset = data.my[0] === "left" ?
                    -data.elemWidth :
                    data.my[0] === "right" ?
                        data.elemWidth :
                        0,
                atOffset = data.at[0] === "left" ?
                    data.targetWidth :
                    data.at[0] === "right" ?
                        -data.targetWidth :
                        0,
                offset = -2 * data.offset[0],
                newOverRight,
                newOverLeft;

            if (overLeft < 0) {
                newOverRight = position.left + myOffset + atOffset + offset + data.collisionWidth - outerWidth - withinOffset;
                if (newOverRight < 0 || newOverRight < abs(overLeft)) {
                    position.left += myOffset + atOffset + offset;
                }
            } else if (overRight > 0) {
                newOverLeft = position.left - data.collisionPosition.marginLeft + myOffset + atOffset + offset - offsetLeft;
                if (newOverLeft > 0 || abs(newOverLeft) < overRight) {
                    position.left += myOffset + atOffset + offset;
                }
            }
        },
        top: function (position, data) {
            var within = data.within,
                withinOffset = within.offset.top + within.scrollTop,
                outerHeight = within.height,
                offsetTop = within.isWindow ? within.scrollTop : within.offset.top,
                collisionPosTop = position.top - data.collisionPosition.marginTop,
                overTop = collisionPosTop - offsetTop,
                overBottom = collisionPosTop + data.collisionHeight - outerHeight - offsetTop,
                top = data.my[1] === "top",
                myOffset = top ?
                    -data.elemHeight :
                    data.my[1] === "bottom" ?
                        data.elemHeight :
                        0,
                atOffset = data.at[1] === "top" ?
                    data.targetHeight :
                    data.at[1] === "bottom" ?
                        -data.targetHeight :
                        0,
                offset = -2 * data.offset[1],
                newOverTop,
                newOverBottom;
            if (overTop < 0) {
                newOverBottom = position.top + myOffset + atOffset + offset + data.collisionHeight - outerHeight - withinOffset;
                if (newOverBottom < 0 || newOverBottom < abs(overTop)) {
                    position.top += myOffset + atOffset + offset;
                }
            } else if (overBottom > 0) {
                newOverTop = position.top - data.collisionPosition.marginTop + myOffset + atOffset + offset - offsetTop;
                if (newOverTop > 0 || abs(newOverTop) < overBottom) {
                    position.top += myOffset + atOffset + offset;
                }
            }
        }
    },
    flipfit: {
        left: function () {
            uiPosition.flip.left.apply(this, arguments);
            uiPosition.fit.left.apply(this, arguments);
        },
        top: function () {
            uiPosition.flip.top.apply(this, arguments);
            uiPosition.fit.top.apply(this, arguments);
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/helpers/ui-position.js
// module id = 691
// module chunks = 4 6 7 8 9 13 17